import { useEffect } from "react"

export const useCatchTimezone = ({ currentDeviceTimezone, setTimezone }) => {
  useEffect(() => {
    if (currentDeviceTimezone) {
      setTimezone(currentDeviceTimezone)
    }
  }, [currentDeviceTimezone])
}
